import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import MuiPhoneNumber from 'material-ui-phone-number';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import {
  ACTIVITY_CTA_TYPES,
  ACTIVITY_CTA_CONTACT_OPTIONS,
} from '../../../../constants/ActivityCalendarConst';

const ActivityCTA = ({ ctaFormData, setCTAFormData }) => {
  const handleCtaStatusChange = (e) => {
    const status = e.target.value === 'Active';
    setCTAFormData({
      ctaStatus: { ...ctaFormData.ctaStatus, value: status },
      ctaType: { ...ctaFormData.ctaType, value: '', errors: {} },
      ctaTitle: { ...ctaFormData.ctaTitle, value: '', errors: {} },
      ctaContact: { ...ctaFormData.ctaContact, value: [], errors: {} },
      ctaEmail: { ...ctaFormData.ctaEmail, value: '', errors: {}, validations: [] },
      ctaPhoneNumber: { ...ctaFormData.ctaPhoneNumber, value: '', errors: {}, validations: [] },
    });
  };

  const handleCTATypeChange = (e) => {
    const newType = e.value;
    const updates = {
      ctaType: e,
      ctaContact: { ...ctaFormData.ctaContact, value: [], errors: {} },
      ctaEmail: { ...ctaFormData.ctaEmail, value: '', errors: {}, validations: [] },
      ctaPhoneNumber: { ...ctaFormData.ctaPhoneNumber, value: '', errors: {}, validations: [] },
    };
    if (newType === 'Enquire') {
      updates.ctaContact = { ...ctaFormData.ctaContact, value: [], validations: ['required'] };
    } else {
      updates.ctaContact = { ...ctaFormData.ctaContact, value: [], validations: [] };
    }
    setCTAFormData(updates);
  };

  const handleContactChange = (e) => {
    const contacts = e.value || [];
    const updates = { ctaContact: e };

    if (contacts.includes('email')) {
      updates.ctaEmail = {
        ...ctaFormData.ctaEmail,
        validations: ['required', 'validEmailList'],
      };
    } else {
      updates.ctaEmail = {
        ...ctaFormData.ctaEmail,
        value: '',
        errors: {},
        validations: [],
      };
    }

    if (contacts.includes('phone')) {
      updates.ctaPhoneNumber = {
        ...ctaFormData.ctaPhoneNumber,
        validations: ['required'],
      };
    } else {
      updates.ctaPhoneNumber = {
        ...ctaFormData.ctaPhoneNumber,
        value: '',
        errors: {},
        validations: [],
      };
    }

    setCTAFormData(updates);
  };

  const handlePhoneNoChange = (phone) => {
    const currField = { ...ctaFormData.ctaPhoneNumber };
    currField.value = phone;
    setCTAFormData({ ctaPhoneNumber: currField });
  };

  return (
    <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
      <div className='custom-upload col-md-12'>
        <RadioGroup
          row
          aria-label='CTA Status'
          onChange={handleCtaStatusChange}
          value={ctaFormData.ctaStatus.value ? 'Active' : 'Inactive'}
          name='ctaStatus'
          className='document-type mb-3'
        >
          <FormControlLabel
            value='Active'
            control={<Radio color='primary' />}
            label='Active'
            className='me-5'
          />
          <FormControlLabel
            value='Inactive'
            control={<Radio color='primary' />}
            label='Inactive'
          />
        </RadioGroup>
      </div>

      {ctaFormData.ctaStatus.value && (
        <>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomSelect
                item={ctaFormData.ctaType}
                handleInputChange={(e) => handleCTATypeChange(e)}
                options={ACTIVITY_CTA_TYPES}
                labelField='name'
                valueField='id'
                hideNullOption
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={ctaFormData.ctaTitle}
                handleInputChange={(e) => {
                  setCTAFormData({ ctaTitle: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>

          {ctaFormData.ctaType.value === 'Enquire' && (
            <>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomMultiSelect
                    item={ctaFormData.ctaContact}
                    labelField='name'
                    valueField='id'
                    options={ACTIVITY_CTA_CONTACT_OPTIONS}
                    hideNullOption={true}
                    handleInputChange={(e) => handleContactChange(e)}
                  />
                </div>
              </div>

              {ctaFormData.ctaContact.value.includes('email') && (
                <div className='row'>
                  <div className='col-md-6'>
                    <CustomTextField
                      item={ctaFormData.ctaEmail}
                      handleInputChange={(e) => {
                        setCTAFormData({ ctaEmail: e });
                      }}
                      maxLength={100000}
                      multiline={true}
                    />
                  </div>
                  <div className='col-md-6 d-flex align-items-center'>
                    <Tooltip
                      title='Add Multiple Email ids, separated by commas'
                      placement='right'
                    >
                      <InfoIcon
                        fontSize='small'
                        className='justify-content-start align-self-center mt-1'
                      />
                    </Tooltip>
                  </div>
                </div>
              )}

              {ctaFormData.ctaContact.value.includes('phone') && (
                <div className='row mt-3'>
                  <div className='col-md-6'>
                    <MuiPhoneNumber
                      name='phone'
                      label='Phone Number'
                      data-cy='user-phone'
                      defaultCountry={'in'}
                      required={true}
                      disableAreaCodes
                      autoFormat={true}
                      countryCodeEditable={false}
                      value={ctaFormData.ctaPhoneNumber.value}
                      className='col-md-12'
                      onChange={(phone) => handlePhoneNoChange(phone)}
                      sx={{ '& svg': { height: '1.2rem' } }}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ActivityCTA;
